const kommundata2022 = [
    {
        registeredVoters: '36189',
        municipality: 'Upplands Väsby',
        votingareas: '1',
        participation: '79,4',
        voters: '28784',
    },
    {
        registeredVoters: '25439',
        municipality: 'Vallentuna',
        votingareas: '1',
        participation: '87,2',
        voters: '22473',
    },
    {
        registeredVoters: '36522',
        municipality: 'Österåker',
        votingareas: '1',
        participation: '85,4',
        voters: '31028',
    },
    {
        registeredVoters: '35047',
        municipality: 'Värmdö',
        votingareas: '1',
        participation: '87,6',
        voters: '30901',
    },
    {
        registeredVoters: '62693',
        municipality: 'Järfälla',
        votingareas: '1',
        participation: '81,6',
        voters: '51282',
    },
    {
        registeredVoters: '21220',
        municipality: 'Ekerö',
        votingareas: '1',
        participation: '89,1',
        voters: '19153',
    },
    {
        registeredVoters: '84108',
        municipality: 'Huddinge',
        votingareas: '1',
        participation: '79,0',
        voters: '67464',
    },
    {
        registeredVoters: '69953',
        municipality: 'Botkyrka',
        votingareas: '1',
        participation: '71,4',
        voters: '50977',
    },
    {
        registeredVoters: '12627',
        municipality: 'Salem',
        votingareas: '1',
        participation: '84,2',
        voters: '10625',
    },
    {
        registeredVoters: '71865',
        municipality: 'Haninge',
        votingareas: '3',
        participation: '78,3',
        voters: '56470',
    },
    {
        registeredVoters: '36886',
        municipality: 'Tyresö',
        votingareas: '1',
        participation: '86,8',
        voters: '32461',
    },
    {
        registeredVoters: '22959',
        municipality: 'Upplands-Bro',
        votingareas: '1',
        participation: '81,7',
        voters: '18773',
    },
    {
        registeredVoters: '8476',
        municipality: 'Nykvarn',
        votingareas: '1',
        participation: '87,7',
        voters: '7486',
    },
    {
        registeredVoters: '55727',
        municipality: 'Täby',
        votingareas: '3',
        participation: '88,7',
        voters: '49511',
    },
    {
        registeredVoters: '24330',
        municipality: 'Danderyd',
        votingareas: '1',
        participation: '90,2',
        voters: '22309',
    },
    {
        registeredVoters: '55484',
        municipality: 'Sollentuna',
        votingareas: '1',
        participation: '84,5',
        voters: '47374',
    },
    {
        registeredVoters: '768007',
        municipality: 'Stockholm',
        votingareas: '7',
        participation: '83,5',
        voters: '646535',
    },
    {
        registeredVoters: '76729',
        municipality: 'Södertälje',
        votingareas: '1',
        participation: '69,9',
        voters: '54330',
    },
    {
        registeredVoters: '80418',
        municipality: 'Nacka',
        votingareas: '3',
        participation: '86,4',
        voters: '70048',
    },
    {
        registeredVoters: '41737',
        municipality: 'Sundbyberg',
        votingareas: '1',
        participation: '80,6',
        voters: '33867',
    },
    {
        registeredVoters: '66364',
        municipality: 'Solna',
        votingareas: '1',
        participation: '82,5',
        voters: '55052',
    },
    {
        registeredVoters: '36482',
        municipality: 'Lidingö',
        votingareas: '1',
        participation: '87,9',
        voters: '32366',
    },
    {
        registeredVoters: '9142',
        municipality: 'Vaxholm',
        votingareas: '1',
        participation: '90,7',
        voters: '8400',
    },
    {
        registeredVoters: '52540',
        municipality: 'Norrtälje',
        votingareas: '1',
        participation: '84,5',
        voters: '44079',
    },
    {
        registeredVoters: '36908',
        municipality: 'Sigtuna',
        votingareas: '1',
        participation: '76,8',
        voters: '28742',
    },
    {
        registeredVoters: '23181',
        municipality: 'Nynäshamn',
        votingareas: '1',
        participation: '82,0',
        voters: '18821',
    },
    {
        registeredVoters: '16946',
        municipality: 'Håbo',
        votingareas: '1',
        participation: '85,9',
        voters: '14573',
    },
    {
        registeredVoters: '7548',
        municipality: 'Älvkarleby',
        votingareas: '1',
        participation: '85,3',
        voters: '6452',
    },
    {
        registeredVoters: '14173',
        municipality: 'Knivsta',
        votingareas: '1',
        participation: '88,7',
        voters: '12518',
    },
    {
        registeredVoters: '11321',
        municipality: 'Heby',
        votingareas: '1',
        participation: '83,9',
        voters: '9490',
    },
    {
        registeredVoters: '16813',
        municipality: 'Tierp',
        votingareas: '1',
        participation: '85,3',
        voters: '14426',
    },
    {
        registeredVoters: '185901',
        municipality: 'Uppsala',
        votingareas: '1',
        participation: '86,4',
        voters: '159844',
    },
    {
        registeredVoters: '36555',
        municipality: 'Enköping',
        votingareas: '1',
        participation: '85,2',
        voters: '30889',
    },
    {
        registeredVoters: '17946',
        municipality: 'Östhammar',
        votingareas: '1',
        participation: '85,1',
        voters: '15266',
    },
    {
        registeredVoters: '7164',
        municipality: 'Vingåker',
        votingareas: '1',
        participation: '86,2',
        voters: '6238',
    },
    {
        registeredVoters: '8915',
        municipality: 'Gnesta',
        votingareas: '1',
        participation: '85,8',
        voters: '7691',
    },
    {
        registeredVoters: '45016',
        municipality: 'Nyköping',
        votingareas: '1',
        participation: '86,3',
        voters: '38794',
    },
    {
        registeredVoters: '9606',
        municipality: 'Oxelösund',
        votingareas: '1',
        participation: '84,0',
        voters: '7988',
    },
    {
        registeredVoters: '12883',
        municipality: 'Flen',
        votingareas: '1',
        participation: '82,1',
        voters: '10697',
    },
    {
        registeredVoters: '26962',
        municipality: 'Katrineholm',
        votingareas: '1',
        participation: '84,7',
        voters: '22984',
    },
    {
        registeredVoters: '82794',
        municipality: 'Eskilstuna',
        votingareas: '1',
        participation: '81,2',
        voters: '67490',
    },
    {
        registeredVoters: '29454',
        municipality: 'Strängnäs',
        votingareas: '1',
        participation: '84,7',
        voters: '24852',
    },
    {
        registeredVoters: '11394',
        municipality: 'Trosa',
        votingareas: '1',
        participation: '87,5',
        voters: '9891',
    },
    {
        registeredVoters: '4238',
        municipality: 'Ödeshög',
        votingareas: '1',
        participation: '85,8',
        voters: '3644',
    },
    {
        registeredVoters: '2979',
        municipality: 'Ydre',
        votingareas: '1',
        participation: '88,3',
        voters: '2658',
    },
    {
        registeredVoters: '7987',
        municipality: 'Kinda',
        votingareas: '1',
        participation: '87,3',
        voters: '6996',
    },
    {
        registeredVoters: '4458',
        municipality: 'Boxholm',
        votingareas: '1',
        participation: '86,8',
        voters: '3843',
    },
    {
        registeredVoters: '9212',
        municipality: 'Åtvidaberg',
        votingareas: '1',
        participation: '87,9',
        voters: '8064',
    },
    {
        registeredVoters: '17300',
        municipality: 'Finspång',
        votingareas: '1',
        participation: '85,5',
        voters: '14807',
    },
    {
        registeredVoters: '6273',
        municipality: 'Valdemarsvik',
        votingareas: '1',
        participation: '86,6',
        voters: '5500',
    },
    {
        registeredVoters: '129575',
        municipality: 'Linköping',
        votingareas: '4',
        participation: '86,6',
        voters: '112366',
    },
    {
        registeredVoters: '112339',
        municipality: 'Norrköping',
        votingareas: '1',
        participation: '83,7',
        voters: '94360',
    },
    {
        registeredVoters: '11489',
        municipality: 'Söderköping',
        votingareas: '1',
        participation: '88,1',
        voters: '10118',
    },
    {
        registeredVoters: '34494',
        municipality: 'Motala',
        votingareas: '1',
        participation: '85,9',
        voters: '29752',
    },
    {
        registeredVoters: '6280',
        municipality: 'Vadstena',
        votingareas: '1',
        participation: '87,3',
        voters: '5400',
    },
    {
        registeredVoters: '22021',
        municipality: 'Mjölby',
        votingareas: '1',
        participation: '86,3',
        voters: '19038',
    },
    {
        registeredVoters: '5334',
        municipality: 'Aneby',
        votingareas: '1',
        participation: '87,5',
        voters: '4698',
    },
    {
        registeredVoters: '7399',
        municipality: 'Gnosjö',
        votingareas: '1',
        participation: '81,5',
        voters: '6105',
    },
    {
        registeredVoters: '5737',
        municipality: 'Mullsjö',
        votingareas: '1',
        participation: '87,3',
        voters: '5003',
    },
    {
        registeredVoters: '9120',
        municipality: 'Habo',
        votingareas: '1',
        participation: '91,0',
        voters: '8322',
    },
    {
        registeredVoters: '22746',
        municipality: 'Gislaved',
        votingareas: '1',
        participation: '81,1',
        voters: '18690',
    },
    {
        registeredVoters: '11173',
        municipality: 'Vaggeryd',
        votingareas: '1',
        participation: '85,0',
        voters: '9536',
    },
    {
        registeredVoters: '111615',
        municipality: 'Jönköping',
        votingareas: '1',
        participation: '85,2',
        voters: '95253',
    },
    {
        registeredVoters: '24306',
        municipality: 'Nässjö',
        votingareas: '1',
        participation: '84,7',
        voters: '20685',
    },
    {
        registeredVoters: '27081',
        municipality: 'Värnamo',
        votingareas: '1',
        participation: '85,1',
        voters: '23157',
    },
    {
        registeredVoters: '8958',
        municipality: 'Sävsjö',
        votingareas: '1',
        participation: '83,9',
        voters: '7543',
    },
    {
        registeredVoters: '21497',
        municipality: 'Vetlanda',
        votingareas: '1',
        participation: '85,1',
        voters: '18383',
    },
    {
        registeredVoters: '14089',
        municipality: 'Eksjö',
        votingareas: '1',
        participation: '85,3',
        voters: '12055',
    },
    {
        registeredVoters: '14829',
        municipality: 'Tranås',
        votingareas: '1',
        participation: '85,4',
        voters: '12729',
    },
    {
        registeredVoters: '7394',
        municipality: 'Uppvidinge',
        votingareas: '1',
        participation: '82,3',
        voters: '6163',
    },
    {
        registeredVoters: '6519',
        municipality: 'Lessebo',
        votingareas: '1',
        participation: '84,5',
        voters: '5580',
    },
    {
        registeredVoters: '9943',
        municipality: 'Tingsryd',
        votingareas: '1',
        participation: '82,9',
        voters: '8225',
    },
    {
        registeredVoters: '15387',
        municipality: 'Alvesta',
        votingareas: '1',
        participation: '85,2',
        voters: '13193',
    },
    {
        registeredVoters: '13275',
        municipality: 'Älmhult',
        votingareas: '1',
        participation: '83,2',
        voters: '11174',
    },
    {
        registeredVoters: '8066',
        municipality: 'Markaryd',
        votingareas: '1',
        participation: '80,2',
        voters: '6498',
    },
    {
        registeredVoters: '74070',
        municipality: 'Växjö',
        votingareas: '1',
        participation: '86,6',
        voters: '63949',
    },
    {
        registeredVoters: '22517',
        municipality: 'Ljungby',
        votingareas: '1',
        participation: '82,4',
        voters: '18702',
    },
    {
        registeredVoters: '4451',
        municipality: 'Högsby',
        votingareas: '1',
        participation: '81,2',
        voters: '3652',
    },
    {
        registeredVoters: '5727',
        municipality: 'Torsås',
        votingareas: '1',
        participation: '85,9',
        voters: '4932',
    },
    {
        registeredVoters: '12345',
        municipality: 'Mörbylånga',
        votingareas: '1',
        participation: '89,7',
        voters: '10969',
    },
    {
        registeredVoters: '11166',
        municipality: 'Hultsfred',
        votingareas: '1',
        participation: '82,4',
        voters: '9235',
    },
    {
        registeredVoters: '10586',
        municipality: 'Mönsterås',
        votingareas: '1',
        participation: '86,2',
        voters: '9138',
    },
    {
        registeredVoters: '7514',
        municipality: 'Emmaboda',
        votingareas: '1',
        participation: '83,3',
        voters: '6274',
    },
    {
        registeredVoters: '56053',
        municipality: 'Kalmar',
        votingareas: '3',
        participation: '86,9',
        voters: '48601',
    },
    {
        registeredVoters: '15975',
        municipality: 'Nybro',
        votingareas: '1',
        participation: '83,1',
        voters: '13340',
    },
    {
        registeredVoters: '21514',
        municipality: 'Oskarshamn',
        votingareas: '1',
        participation: '86,1',
        voters: '18623',
    },
    {
        registeredVoters: '29824',
        municipality: 'Västervik',
        votingareas: '1',
        participation: '84,4',
        voters: '25154',
    },
    {
        registeredVoters: '12400',
        municipality: 'Vimmerby',
        votingareas: '1',
        participation: '86,3',
        voters: '10769',
    },
    {
        registeredVoters: '9183',
        municipality: 'Borgholm',
        votingareas: '1',
        participation: '86,4',
        voters: '7941',
    },
    {
        registeredVoters: '49330',
        municipality: 'Gotland',
        votingareas: '1',
        participation: '86,8',
        voters: '42476',
    },
    {
        registeredVoters: '10759',
        municipality: 'Olofström',
        votingareas: '1',
        participation: '81,6',
        voters: '8784',
    },
    {
        registeredVoters: '52425',
        municipality: 'Karlskrona',
        votingareas: '4',
        participation: '87,2',
        voters: '45949',
    },
    {
        registeredVoters: '22766',
        municipality: 'Ronneby',
        votingareas: '1',
        participation: '85,8',
        voters: '19616',
    },
    {
        registeredVoters: '25754',
        municipality: 'Karlshamn',
        votingareas: '1',
        participation: '85,6',
        voters: '22148',
    },
    {
        registeredVoters: '14239',
        municipality: 'Sölvesborg',
        votingareas: '1',
        participation: '86,0',
        voters: '12214',
    },
    {
        registeredVoters: '10960',
        municipality: 'Svalöv',
        votingareas: '1',
        participation: '83,2',
        voters: '9115',
    },
    {
        registeredVoters: '19203',
        municipality: 'Staffanstorp',
        votingareas: '1',
        participation: '88,9',
        voters: '17137',
    },
    {
        registeredVoters: '14729',
        municipality: 'Burlöv',
        votingareas: '1',
        participation: '76,4',
        voters: '11331',
    },
    {
        registeredVoters: '28554',
        municipality: 'Vellinge',
        votingareas: '1',
        participation: '92,3',
        voters: '26237',
    },
    {
        registeredVoters: '11331',
        municipality: 'Östra Göinge',
        votingareas: '1',
        participation: '83,7',
        voters: '9623',
    },
    {
        registeredVoters: '8289',
        municipality: 'Örkelljunga',
        votingareas: '1',
        participation: '81,0',
        voters: '6692',
    },
    {
        registeredVoters: '12026',
        municipality: 'Bjuv',
        votingareas: '1',
        participation: '76,5',
        voters: '9260',
    },
    {
        registeredVoters: '24002',
        municipality: 'Kävlinge',
        votingareas: '1',
        participation: '89,3',
        voters: '21580',
    },
    {
        registeredVoters: '17953',
        municipality: 'Lomma',
        votingareas: '1',
        participation: '92,9',
        voters: '16942',
    },
    {
        registeredVoters: '16982',
        municipality: 'Svedala',
        votingareas: '1',
        participation: '88,9',
        voters: '15032',
    },
    {
        registeredVoters: '12786',
        municipality: 'Skurup',
        votingareas: '1',
        participation: '85,4',
        voters: '10838',
    },
    {
        registeredVoters: '15530',
        municipality: 'Sjöbo',
        votingareas: '1',
        participation: '83,5',
        voters: '12954',
    },
    {
        registeredVoters: '12446',
        municipality: 'Hörby',
        votingareas: '1',
        participation: '84,1',
        voters: '10482',
    },
    {
        registeredVoters: '13131',
        municipality: 'Höör',
        votingareas: '1',
        participation: '86,0',
        voters: '11278',
    },
    {
        registeredVoters: '10859',
        municipality: 'Tomelilla',
        votingareas: '1',
        participation: '83,3',
        voters: '9069',
    },
    {
        registeredVoters: '9889',
        municipality: 'Bromölla',
        votingareas: '1',
        participation: '85,1',
        voters: '8549',
    },
    {
        registeredVoters: '10442',
        municipality: 'Osby',
        votingareas: '1',
        participation: '84,0',
        voters: '8771',
    },
    {
        registeredVoters: '5708',
        municipality: 'Perstorp',
        votingareas: '1',
        participation: '76,6',
        voters: '4400',
    },
    {
        registeredVoters: '14071',
        municipality: 'Klippan',
        votingareas: '1',
        participation: '78,8',
        voters: '11161',
    },
    {
        registeredVoters: '11992',
        municipality: 'Åstorp',
        votingareas: '1',
        participation: '77,2',
        voters: '9355',
    },
    {
        registeredVoters: '12742',
        municipality: 'Båstad',
        votingareas: '1',
        participation: '86,6',
        voters: '10960',
    },
    {
        registeredVoters: '269489',
        municipality: 'Malmö',
        votingareas: '3',
        participation: '78,6',
        voters: '212817',
    },
    {
        registeredVoters: '99816',
        municipality: 'Lund',
        votingareas: '1',
        participation: '86,4',
        voters: '86012',
    },
    {
        registeredVoters: '35730',
        municipality: 'Landskrona',
        votingareas: '1',
        participation: '79,8',
        voters: '28649',
    },
    {
        registeredVoters: '115842',
        municipality: 'Helsingborg',
        votingareas: '1',
        participation: '81,7',
        voters: '95522',
    },
    {
        registeredVoters: '21794',
        municipality: 'Höganäs',
        votingareas: '1',
        participation: '86,2',
        voters: '18607',
    },
    {
        registeredVoters: '26240',
        municipality: 'Eslöv',
        votingareas: '1',
        participation: '83,6',
        voters: '22049',
    },
    {
        registeredVoters: '25576',
        municipality: 'Ystad',
        votingareas: '1',
        participation: '86,5',
        voters: '21949',
    },
    {
        registeredVoters: '36082',
        municipality: 'Trelleborg',
        votingareas: '3',
        participation: '83,4',
        voters: '30191',
    },
    {
        registeredVoters: '67583',
        municipality: 'Kristianstad',
        votingareas: '3',
        participation: '84,1',
        voters: '57078',
    },
    {
        registeredVoters: '16116',
        municipality: 'Simrishamn',
        votingareas: '1',
        participation: '85,0',
        voters: '13689',
    },
    {
        registeredVoters: '34396',
        municipality: 'Ängelholm',
        votingareas: '1',
        participation: '85,2',
        voters: '29144',
    },
    {
        registeredVoters: '41356',
        municipality: 'Hässleholm',
        votingareas: '1',
        participation: '83,5',
        voters: '34628',
    },
    {
        registeredVoters: '8128',
        municipality: 'Hylte',
        votingareas: '1',
        participation: '80,5',
        voters: '6607',
    },
    {
        registeredVoters: '81561',
        municipality: 'Halmstad',
        votingareas: '1',
        participation: '85,1',
        voters: '69640',
    },
    {
        registeredVoters: '20838',
        municipality: 'Laholm',
        votingareas: '1',
        participation: '84,6',
        voters: '17522',
    },
    {
        registeredVoters: '36754',
        municipality: 'Falkenberg',
        votingareas: '1',
        participation: '85,5',
        voters: '31372',
    },
    {
        registeredVoters: '52494',
        municipality: 'Varberg',
        votingareas: '3',
        participation: '88,1',
        voters: '45925',
    },
    {
        registeredVoters: '64584',
        municipality: 'Kungsbacka',
        votingareas: '1',
        participation: '90,0',
        voters: '58614',
    },
    {
        registeredVoters: '28830',
        municipality: 'Härryda',
        votingareas: '1',
        participation: '88,9',
        voters: '25434',
    },
    {
        registeredVoters: '29406',
        municipality: 'Partille',
        votingareas: '1',
        participation: '85,9',
        voters: '25674',
    },
    {
        registeredVoters: '10231',
        municipality: 'Öckerö',
        votingareas: '1',
        participation: '90,9',
        voters: '9395',
    },
    {
        registeredVoters: '21171',
        municipality: 'Stenungsund',
        votingareas: '1',
        participation: '87,7',
        voters: '18518',
    },
    {
        registeredVoters: '13039',
        municipality: 'Tjörn',
        votingareas: '1',
        participation: '88,8',
        voters: '11545',
    },
    {
        registeredVoters: '12564',
        municipality: 'Orust',
        votingareas: '1',
        participation: '87,2',
        voters: '10987',
    },
    {
        registeredVoters: '7772',
        municipality: 'Sotenäs',
        votingareas: '1',
        participation: '86,8',
        voters: '6726',
    },
    {
        registeredVoters: '8341',
        municipality: 'Munkedal',
        votingareas: '1',
        participation: '84,5',
        voters: '7117',
    },
    {
        registeredVoters: '10511',
        municipality: 'Tanum',
        votingareas: '1',
        participation: '84,9',
        voters: '8923',
    },
    {
        registeredVoters: '3830',
        municipality: 'Dals-Ed',
        votingareas: '1',
        participation: '79,3',
        voters: '3063',
    },
    {
        registeredVoters: '5234',
        municipality: 'Färgelanda',
        votingareas: '1',
        participation: '84,3',
        voters: '4433',
    },
    {
        registeredVoters: '24038',
        municipality: 'Ale',
        votingareas: '1',
        participation: '85,5',
        voters: '20752',
    },
    {
        registeredVoters: '31744',
        municipality: 'Lerum',
        votingareas: '1',
        participation: '89,8',
        voters: '28785',
    },
    {
        registeredVoters: '9298',
        municipality: 'Vårgårda',
        votingareas: '1',
        participation: '87,6',
        voters: '8150',
    },
    {
        registeredVoters: '7326',
        municipality: 'Bollebygd',
        votingareas: '1',
        participation: '88,9',
        voters: '6523',
    },
    {
        registeredVoters: '4596',
        municipality: 'Grästorp',
        votingareas: '1',
        participation: '87,1',
        voters: '4014',
    },
    {
        registeredVoters: '4472',
        municipality: 'Essunga',
        votingareas: '1',
        participation: '85,8',
        voters: '3863',
    },
    {
        registeredVoters: '5719',
        municipality: 'Karlsborg',
        votingareas: '1',
        participation: '87,6',
        voters: '4963',
    },
    {
        registeredVoters: '4268',
        municipality: 'Gullspång',
        votingareas: '1',
        participation: '82,5',
        voters: '3535',
    },
    {
        registeredVoters: '9388',
        municipality: 'Tranemo',
        votingareas: '1',
        participation: '85,6',
        voters: '8048',
    },
    {
        registeredVoters: '7702',
        municipality: 'Bengtsfors',
        votingareas: '1',
        participation: '81,3',
        voters: '6281',
    },
    {
        registeredVoters: '7420',
        municipality: 'Mellerud',
        votingareas: '1',
        participation: '82,6',
        voters: '6140',
    },
    {
        registeredVoters: '11205',
        municipality: 'Lilla Edet',
        votingareas: '1',
        participation: '81,6',
        voters: '9188',
    },
    {
        registeredVoters: '27541',
        municipality: 'Mark',
        votingareas: '1',
        participation: '85,3',
        voters: '23490',
    },
    {
        registeredVoters: '8548',
        municipality: 'Svenljunga',
        votingareas: '1',
        participation: '84,1',
        voters: '7166',
    },
    {
        registeredVoters: '7563',
        municipality: 'Herrljunga',
        votingareas: '1',
        participation: '86,5',
        voters: '6533',
    },
    {
        registeredVoters: '12807',
        municipality: 'Vara',
        votingareas: '1',
        participation: '84,0',
        voters: '10845',
    },
    {
        registeredVoters: '10581',
        municipality: 'Götene',
        votingareas: '1',
        participation: '86,7',
        voters: '9147',
    },
    {
        registeredVoters: '8904',
        municipality: 'Tibro',
        votingareas: '1',
        participation: '85,6',
        voters: '7618',
    },
    {
        registeredVoters: '7362',
        municipality: 'Töreboda',
        votingareas: '1',
        participation: '83,4',
        voters: '6208',
    },
    {
        registeredVoters: '460267',
        municipality: 'Göteborg',
        votingareas: '1',
        participation: '81,0',
        voters: '375053',
    },
    {
        registeredVoters: '53506',
        municipality: 'Mölndal',
        votingareas: '1',
        participation: '86,8',
        voters: '46940',
    },
    {
        registeredVoters: '37295',
        municipality: 'Kungälv',
        votingareas: '1',
        participation: '89,3',
        voters: '33034',
    },
    {
        registeredVoters: '11610',
        municipality: 'Lysekil',
        votingareas: '1',
        participation: '85,4',
        voters: '9979',
    },
    {
        registeredVoters: '44318',
        municipality: 'Uddevalla',
        votingareas: '1',
        participation: '84,8',
        voters: '37698',
    },
    {
        registeredVoters: '10351',
        municipality: 'Strömstad',
        votingareas: '1',
        participation: '76,7',
        voters: '8009',
    },
    {
        registeredVoters: '30993',
        municipality: 'Vänersborg',
        votingareas: '1',
        participation: '85,6',
        voters: '26604',
    },
    {
        registeredVoters: '45673',
        municipality: 'Trollhättan',
        votingareas: '3',
        participation: '84,4',
        voters: '38921',
    },
    {
        registeredVoters: '32330',
        municipality: 'Alingsås',
        votingareas: '1',
        participation: '88,0',
        voters: '28568',
    },
    {
        registeredVoters: '88271',
        municipality: 'Borås',
        votingareas: '4',
        participation: '83,4',
        voters: '74125',
    },
    {
        registeredVoters: '19628',
        municipality: 'Ulricehamn',
        votingareas: '1',
        participation: '85,2',
        voters: '16680',
    },
    {
        registeredVoters: '9853',
        municipality: 'Åmål',
        votingareas: '1',
        participation: '83,0',
        voters: '8269',
    },
    {
        registeredVoters: '19918',
        municipality: 'Mariestad',
        votingareas: '1',
        participation: '84,9',
        voters: '16864',
    },
    {
        registeredVoters: '32097',
        municipality: 'Lidköping',
        votingareas: '1',
        participation: '87,8',
        voters: '28284',
    },
    {
        registeredVoters: '14778',
        municipality: 'Skara',
        votingareas: '1',
        participation: '85,0',
        voters: '12715',
    },
    {
        registeredVoters: '44897',
        municipality: 'Skövde',
        votingareas: '1',
        participation: '85,3',
        voters: '38303',
    },
    {
        registeredVoters: '7378',
        municipality: 'Hjo',
        votingareas: '1',
        participation: '86,6',
        voters: '6388',
    },
    {
        registeredVoters: '10193',
        municipality: 'Tidaholm',
        votingareas: '1',
        participation: '86,4',
        voters: '8827',
    },
    {
        registeredVoters: '25671',
        municipality: 'Falköping',
        votingareas: '1',
        participation: '85,7',
        voters: '22117',
    },
    {
        registeredVoters: '9426',
        municipality: 'Kil',
        votingareas: '1',
        participation: '87,3',
        voters: '8279',
    },
    {
        registeredVoters: '6743',
        municipality: 'Eda',
        votingareas: '1',
        participation: '70,5',
        voters: '4767',
    },
    {
        registeredVoters: '9468',
        municipality: 'Torsby',
        votingareas: '1',
        participation: '80,3',
        voters: '7603',
    },
    {
        registeredVoters: '3226',
        municipality: 'Storfors',
        votingareas: '1',
        participation: '83,9',
        voters: '2731',
    },
    {
        registeredVoters: '12409',
        municipality: 'Hammarö',
        votingareas: '1',
        participation: '89,6',
        voters: '11209',
    },
    {
        registeredVoters: '2993',
        municipality: 'Munkfors',
        votingareas: '1',
        participation: '80,6',
        voters: '2404',
    },
    {
        registeredVoters: '8969',
        municipality: 'Forshaga',
        votingareas: '1',
        participation: '87,1',
        voters: '7829',
    },
    {
        registeredVoters: '7288',
        municipality: 'Grums',
        votingareas: '1',
        participation: '83,3',
        voters: '6078',
    },
    {
        registeredVoters: '7948',
        municipality: 'Årjäng',
        votingareas: '1',
        participation: '76,5',
        voters: '6155',
    },
    {
        registeredVoters: '10768',
        municipality: 'Sunne',
        votingareas: '1',
        participation: '85,4',
        voters: '9200',
    },
    {
        registeredVoters: '76463',
        municipality: 'Karlstad',
        votingareas: '1',
        participation: '87,2',
        voters: '66436',
    },
    {
        registeredVoters: '19443',
        municipality: 'Kristinehamn',
        votingareas: '1',
        participation: '84,7',
        voters: '16494',
    },
    {
        registeredVoters: '8376',
        municipality: 'Filipstad',
        votingareas: '1',
        participation: '80,5',
        voters: '6776',
    },
    {
        registeredVoters: '9641',
        municipality: 'Hagfors',
        votingareas: '1',
        participation: '81,0',
        voters: '7825',
    },
    {
        registeredVoters: '20808',
        municipality: 'Arvika',
        votingareas: '1',
        participation: '83,1',
        voters: '17321',
    },
    {
        registeredVoters: '12364',
        municipality: 'Säffle',
        votingareas: '1',
        participation: '82,9',
        voters: '10330',
    },
    {
        registeredVoters: '6462',
        municipality: 'Lekeberg',
        votingareas: '1',
        participation: '88,8',
        voters: '5692',
    },
    {
        registeredVoters: '4505',
        municipality: 'Laxå',
        votingareas: '1',
        participation: '83,3',
        voters: '3796',
    },
    {
        registeredVoters: '12542',
        municipality: 'Hallsberg',
        votingareas: '1',
        participation: '85,8',
        voters: '10712',
    },
    {
        registeredVoters: '7750',
        municipality: 'Degerfors',
        votingareas: '1',
        participation: '84,9',
        voters: '6629',
    },
    {
        registeredVoters: '5459',
        municipality: 'Hällefors',
        votingareas: '1',
        participation: '81,1',
        voters: '4443',
    },
    {
        registeredVoters: '3825',
        municipality: 'Ljusnarsberg',
        votingareas: '1',
        participation: '79,3',
        voters: '3078',
    },
    {
        registeredVoters: '122322',
        municipality: 'Örebro',
        votingareas: '3',
        participation: '85,7',
        voters: '104914',
    },
    {
        registeredVoters: '16877',
        municipality: 'Kumla',
        votingareas: '1',
        participation: '86,6',
        voters: '14615',
    },
    {
        registeredVoters: '9339',
        municipality: 'Askersund',
        votingareas: '1',
        participation: '87,1',
        voters: '8140',
    },
    {
        registeredVoters: '24353',
        municipality: 'Karlskoga',
        votingareas: '1',
        participation: '84,5',
        voters: '20626',
    },
    {
        registeredVoters: '8521',
        municipality: 'Nora',
        votingareas: '1',
        participation: '84,6',
        voters: '7217',
    },
    {
        registeredVoters: '18740',
        municipality: 'Lindesberg',
        votingareas: '1',
        participation: '84,9',
        voters: '15948',
    },
    {
        registeredVoters: '3601',
        municipality: 'Skinnskatteberg',
        votingareas: '1',
        participation: '83,0',
        voters: '2961',
    },
    {
        registeredVoters: '7901',
        municipality: 'Surahammar',
        votingareas: '1',
        participation: '81,5',
        voters: '6478',
    },
    {
        registeredVoters: '6854',
        municipality: 'Kungsör',
        votingareas: '1',
        participation: '85,5',
        voters: '5899',
    },
    {
        registeredVoters: '12969',
        municipality: 'Hallstahammar',
        votingareas: '1',
        participation: '82,6',
        voters: '10696',
    },
    {
        registeredVoters: '4553',
        municipality: 'Norberg',
        votingareas: '1',
        participation: '84,1',
        voters: '3881',
    },
    {
        registeredVoters: '121763',
        municipality: 'Västerås',
        votingareas: '1',
        participation: '84,0',
        voters: '102676',
    },
    {
        registeredVoters: '18174',
        municipality: 'Sala',
        votingareas: '1',
        participation: '85,8',
        voters: '15638',
    },
    {
        registeredVoters: '10270',
        municipality: 'Fagersta',
        votingareas: '1',
        participation: '80,6',
        voters: '8345',
    },
    {
        registeredVoters: '20539',
        municipality: 'Köping',
        votingareas: '1',
        participation: '82,8',
        voters: '17121',
    },
    {
        registeredVoters: '11289',
        municipality: 'Arboga',
        votingareas: '1',
        participation: '84,2',
        voters: '9578',
    },
    {
        registeredVoters: '5485',
        municipality: 'Vansbro',
        votingareas: '1',
        participation: '84,5',
        voters: '4636',
    },
    {
        registeredVoters: '8338',
        municipality: 'Malung-Sälen',
        votingareas: '1',
        participation: '84,4',
        voters: '7012',
    },
    {
        registeredVoters: '8110',
        municipality: 'Gagnef',
        votingareas: '1',
        participation: '87,8',
        voters: '7119',
    },
    {
        registeredVoters: '12945',
        municipality: 'Leksand',
        votingareas: '1',
        participation: '87,8',
        voters: '11321',
    },
    {
        registeredVoters: '9256',
        municipality: 'Rättvik',
        votingareas: '1',
        participation: '85,4',
        voters: '7874',
    },
    {
        registeredVoters: '5704',
        municipality: 'Orsa',
        votingareas: '1',
        participation: '84,5',
        voters: '4826',
    },
    {
        registeredVoters: '5703',
        municipality: 'Älvdalen',
        votingareas: '1',
        participation: '84,3',
        voters: '4824',
    },
    {
        registeredVoters: '8820',
        municipality: 'Smedjebacken',
        votingareas: '1',
        participation: '85,8',
        voters: '7545',
    },
    {
        registeredVoters: '16649',
        municipality: 'Mora',
        votingareas: '1',
        participation: '84,4',
        voters: '14024',
    },
    {
        registeredVoters: '46795',
        municipality: 'Falun',
        votingareas: '1',
        participation: '86,9',
        voters: '40802',
    },
    {
        registeredVoters: '40337',
        municipality: 'Borlänge',
        votingareas: '1',
        participation: '85,1',
        voters: '34644',
    },
    {
        registeredVoters: '8924',
        municipality: 'Säter',
        votingareas: '1',
        participation: '87,2',
        voters: '7766',
    },
    {
        registeredVoters: '12333',
        municipality: 'Hedemora',
        votingareas: '1',
        participation: '83,0',
        voters: '10304',
    },
    {
        registeredVoters: '18124',
        municipality: 'Avesta',
        votingareas: '1',
        participation: '83,6',
        voters: '15244',
    },
    {
        registeredVoters: '20596',
        municipality: 'Ludvika',
        votingareas: '1',
        participation: '84,6',
        voters: '17626',
    },
    {
        registeredVoters: '4780',
        municipality: 'Ockelbo',
        votingareas: '1',
        participation: '84,7',
        voters: '4077',
    },
    {
        registeredVoters: '7698',
        municipality: 'Hofors',
        votingareas: '1',
        participation: '81,9',
        voters: '6314',
    },
    {
        registeredVoters: '9312',
        municipality: 'Ovanåker',
        votingareas: '1',
        participation: '84,5',
        voters: '7916',
    },
    {
        registeredVoters: '7552',
        municipality: 'Nordanstig',
        votingareas: '1',
        participation: '81,6',
        voters: '6184',
    },
    {
        registeredVoters: '15173',
        municipality: 'Ljusdal',
        votingareas: '1',
        participation: '80,6',
        voters: '12300',
    },
    {
        registeredVoters: '81188',
        municipality: 'Gävle',
        votingareas: '1',
        participation: '85,6',
        voters: '69843',
    },
    {
        registeredVoters: '31036',
        municipality: 'Sandviken',
        votingareas: '1',
        participation: '84,4',
        voters: '26348',
    },
    {
        registeredVoters: '20437',
        municipality: 'Söderhamn',
        votingareas: '1',
        participation: '84,3',
        voters: '17290',
    },
    {
        registeredVoters: '21245',
        municipality: 'Bollnäs',
        votingareas: '1',
        participation: '83,8',
        voters: '17870',
    },
    {
        registeredVoters: '30132',
        municipality: 'Hudiksvall',
        votingareas: '1',
        participation: '83,3',
        voters: '25216',
    },
    {
        registeredVoters: '7547',
        municipality: 'Ånge',
        votingareas: '1',
        participation: '83,6',
        voters: '6359',
    },
    {
        registeredVoters: '14208',
        municipality: 'Timrå',
        votingareas: '1',
        participation: '85,8',
        voters: '12337',
    },
    {
        registeredVoters: '19843',
        municipality: 'Härnösand',
        votingareas: '1',
        participation: '85,3',
        voters: '17111',
    },
    {
        registeredVoters: '78577',
        municipality: 'Sundsvall',
        votingareas: '3',
        participation: '85,8',
        voters: '67833',
    },
    {
        registeredVoters: '14757',
        municipality: 'Kramfors',
        votingareas: '1',
        participation: '83,5',
        voters: '12410',
    },
    {
        registeredVoters: '15175',
        municipality: 'Sollefteå',
        votingareas: '1',
        participation: '83,9',
        voters: '12796',
    },
    {
        registeredVoters: '44040',
        municipality: 'Örnsköldsvik',
        votingareas: '3',
        participation: '86,7',
        voters: '38388',
    },
    {
        registeredVoters: '4203',
        municipality: 'Ragunda',
        votingareas: '1',
        participation: '83,0',
        voters: '3476',
    },
    {
        registeredVoters: '5049',
        municipality: 'Bräcke',
        votingareas: '1',
        participation: '81,5',
        voters: '4123',
    },
    {
        registeredVoters: '11537',
        municipality: 'Krokom',
        votingareas: '1',
        participation: '86,5',
        voters: '9982',
    },
    {
        registeredVoters: '9303',
        municipality: 'Strömsund',
        votingareas: '1',
        participation: '81,3',
        voters: '7561',
    },
    {
        registeredVoters: '9584',
        municipality: 'Åre',
        votingareas: '1',
        participation: '86,0',
        voters: '8066',
    },
    {
        registeredVoters: '5690',
        municipality: 'Berg',
        votingareas: '1',
        participation: '83,2',
        voters: '4727',
    },
    {
        registeredVoters: '8435',
        municipality: 'Härjedalen',
        votingareas: '1',
        participation: '81,4',
        voters: '6821',
    },
    {
        registeredVoters: '50836',
        municipality: 'Östersund',
        votingareas: '1',
        participation: '85,8',
        voters: '43768',
    },
    {
        registeredVoters: '5691',
        municipality: 'Nordmaling',
        votingareas: '1',
        participation: '84,0',
        voters: '4808',
    },
    {
        registeredVoters: '1907',
        municipality: 'Bjurholm',
        votingareas: '1',
        participation: '84,2',
        voters: '1605',
    },
    {
        registeredVoters: '4339',
        municipality: 'Vindeln',
        votingareas: '1',
        participation: '82,2',
        voters: '3576',
    },
    {
        registeredVoters: '5339',
        municipality: 'Robertsfors',
        votingareas: '1',
        participation: '85,0',
        voters: '4570',
    },
    {
        registeredVoters: '3159',
        municipality: 'Norsjö',
        votingareas: '1',
        participation: '81,0',
        voters: '2554',
    },
    {
        registeredVoters: '2407',
        municipality: 'Malå',
        votingareas: '1',
        participation: '82,4',
        voters: '2006',
    },
    {
        registeredVoters: '4727',
        municipality: 'Storuman',
        votingareas: '1',
        participation: '81,5',
        voters: '3838',
    },
    {
        registeredVoters: '1988',
        municipality: 'Sorsele',
        votingareas: '1',
        participation: '77,4',
        voters: '1548',
    },
    {
        registeredVoters: '2003',
        municipality: 'Dorotea',
        votingareas: '1',
        participation: '83,2',
        voters: '1691',
    },
    {
        registeredVoters: '6888',
        municipality: 'Vännäs',
        votingareas: '1',
        participation: '85,2',
        voters: '5904',
    },
    {
        registeredVoters: '5246',
        municipality: 'Vilhelmina',
        votingareas: '1',
        participation: '82,8',
        voters: '4401',
    },
    {
        registeredVoters: '2313',
        municipality: 'Åsele',
        votingareas: '1',
        participation: '81,2',
        voters: '1869',
    },
    {
        registeredVoters: '103392',
        municipality: 'Umeå',
        votingareas: '3',
        participation: '87,1',
        voters: '89581',
    },
    {
        registeredVoters: '9612',
        municipality: 'Lycksele',
        votingareas: '1',
        participation: '82,4',
        voters: '7974',
    },
    {
        registeredVoters: '58207',
        municipality: 'Skellefteå',
        votingareas: '2',
        participation: '86,2',
        voters: '50363',
    },
    {
        registeredVoters: '4986',
        municipality: 'Arvidsjaur',
        votingareas: '1',
        participation: '82,7',
        voters: '4144',
    },
    {
        registeredVoters: '2251',
        municipality: 'Arjeplog',
        votingareas: '1',
        participation: '80,7',
        voters: '1808',
    },
    {
        registeredVoters: '3971',
        municipality: 'Jokkmokk',
        votingareas: '1',
        participation: '81,4',
        voters: '3260',
    },
    {
        registeredVoters: '2738',
        municipality: 'Överkalix',
        votingareas: '1',
        participation: '83,0',
        voters: '2279',
    },
    {
        registeredVoters: '12910',
        municipality: 'Kalix',
        votingareas: '1',
        participation: '85,0',
        voters: '11020',
    },
    {
        registeredVoters: '3554',
        municipality: 'Övertorneå',
        votingareas: '1',
        participation: '76,2',
        voters: '2704',
    },
    {
        registeredVoters: '4885',
        municipality: 'Pajala',
        votingareas: '1',
        participation: '78,8',
        voters: '3867',
    },
    {
        registeredVoters: '14131',
        municipality: 'Gällivare',
        votingareas: '1',
        participation: '80,1',
        voters: '11392',
    },
    {
        registeredVoters: '6459',
        municipality: 'Älvsbyn',
        votingareas: '1',
        participation: '83,3',
        voters: '5434',
    },
    {
        registeredVoters: '63166',
        municipality: 'Luleå',
        votingareas: '1',
        participation: '86,9',
        voters: '54876',
    },
    {
        registeredVoters: '33836',
        municipality: 'Piteå',
        votingareas: '1',
        participation: '88,2',
        voters: '30022',
    },
    {
        registeredVoters: '22777',
        municipality: 'Boden',
        votingareas: '1',
        participation: '86,1',
        voters: '19656',
    },
    {
        registeredVoters: '7628',
        municipality: 'Haparanda',
        votingareas: '1',
        participation: '63,3',
        voters: '4891',
    },
    {
        registeredVoters: '17955',
        municipality: 'Kiruna',
        votingareas: '1',
        participation: '83,3',
        voters: '15084',
    },
]

export default kommundata2022
